import React from 'react';
import { Container } from 'components/UI';
import { Title, Image, LazyImage } from '@landing/ui';

import * as styles from './Offices.module.scss';

export default function Offices({ title, map, offices }) {
  return (
    <Container id="offices" className={styles.container} background="gray" theme="stairs">
      <div className={styles.wrapper}>
        <div className={styles.layout}>
          <Title tag="h2" className={styles.title}>
            {title}
          </Title>
          <div className={styles.content}>
            {offices.map(({ title, mobileTitle, items }) => (
              <div key={title} className={styles.group}>
                <div className={styles.groupTitle}>
                  <span className={styles.showTablet}>{title}</span>
                  <span className={styles.showMobile}>{mobileTitle}</span>
                </div>
                <ul className={styles.list}>
                  {items.map(({ flag, country, mobileCountry, city }) => (
                    <li key={country} className={styles.item}>
                      <LazyImage className={styles.flag} src={flag} />
                      <span className={mobileCountry && styles.showTablet}>
                        {country}
                        {city && ` — ${city}`}
                      </span>
                      <span className={styles.showMobile}>{mobileCountry}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <Image className={styles.mapWrap} classImage={styles.map} src={map} />
        </div>
      </div>
    </Container>
  );
}
